import type { GetFeaturesInnerParams } from '@/app/components/search/components/EvolutionCard/Details/Features/getFeatures/types.ts';
import { getFacilities } from '@/app/components/search/components/EvolutionCard/utils/getFacilities.tsx';
import { getTotalNumChildrenInfants } from '@/utils/peopleUtils.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import type { Feature } from '@/app/components/search/components/EvolutionCard/utils/facilitiesTypes.ts';

// The card shows at most three of them, alongside the USPs it already carries.
const MAX_FACILITIES = 3;

export const getFacilitiesFeatures = ({
  isHO,
  isOverlay,
  accommodation,
  imageBasePath,
  t,
  searchParams,
}: GetFeaturesInnerParams): Feature[] => {
  // The TSX card hides them on the map overlay too: the popup has no room for three more rows.
  if (!isHO || isOverlay || !accommodation?.facilities) return [];

  return getFacilities({
    facilities: accommodation.facilities,
    imageBasePath,
    max: MAX_FACILITIES,
    t,
    hasChildren: getTotalNumChildrenInfants(searchParams[URLParameters.AGES]) > 0,
  });
};
